import About from '../components/About'

function Home({ t, lang }) {
  return (
        <main className="page-container bg-custom">
            <div className='container text-center'>
              <h1 className='page-title'>{t("nav_about").toUpperCase()}</h1>
              <About lang={lang} />
            </div>
        </main>
  );
}

export default Home;